import axios from 'axios'
const url = '/contabilidad/asiento-tipo'

export default {
    create(data) {
        return axios.post(url, data)
    },
    update(data) {
        return axios.put(`${url}/${data.id}`, data)
    },
    index(sucursalUuid = null) {
        console.log(sucursalUuid);
        
        const config = {};

        if (sucursalUuid) {
            config.params = { sucursal_uuid: sucursalUuid };
        }

        return axios.get(url, config);
    },
    delete(data) {

        return axios.delete(`${url}/${data.id}`)

    },
    show(id) {
        return axios.get(`${url}/${id}`)
    },


}